export default {
  featuredExperiences: '\u00d6ne \u00c7\u0131kan Deneyimlerimiz',
  searchAllExperiences: 'T\u00fcm Deneyimleri Ara',
  searchAll: 'T\u00fcm\u00fcn\u00fc Ara',
  groupSize: 'Grup B\u00fcy\u00fckl\u00fc\u011f\u00fc',
  eventSize: 'Etkinlik B\u00fcy\u00fckl\u00fc\u011f\u00fc',
  upTo: 'En fazla',
  whatWeDo: 'Neler Yapaca\u011f\u0131z',
  hostedBy: 'Sunan',
  whatsIncluded: 'Neler Dahil',
  avail: 'Uygunluk',
  whereWeAre: 'Nerede Olaca\u011f\u0131z',
  experienceCalendar: 'Deneyim Takvimi',
  experienceCancelled: 'Deneyim \u0130ptal Edildi',
  experienceStartingPrice: '{{price}} ile ba\u015flayan',
  experienceTotalPrice: 'Toplam {{price}}',
  at: 'saat',
  viewPrivateSessAvailability:
    '\u00d6zel seans uygunlu\u011funu g\u00f6r\u00fcnt\u00fcle',
  selectDuration: 'S\u00fcre',
  selectStartTime: 'Ba\u015flang\u0131\u00e7 saati',
  selectSession: 'Seans Se\u00e7in',
  sessionsCount: '{{count}} zaman — bir zaman seçin',
  noAvailability: 'Uygunluk Yok',
  select: 'Se\u00e7',
  slotLeft: '{{remainSlots}} yer kald\u0131',
  slotsLeft: '{{remainSlots}} yer kald\u0131',
  spotsLeft: '{{count}} kaldı',
  spotsLeftAriaLabel: '{{count}} yer kaldı',
  bookExperience: 'Deneyim Rezerve Et',
  book: 'Rezerve Et',
  learnMore: 'Daha fazla bilgi',
  apply: 'Uygula',
  maxPartySizes: 'Grup ba\u015f\u0131na en fazla {{maxGroupSize}} yer',
  maxPartySize: 'Grup ba\u015f\u0131na en fazla {{maxGroupSize}} yer',
  selectSessionValidation: 'L\u00fctfen seans se\u00e7in',
  selectParticipantValidation:
    'L\u00fctfen kat\u0131l\u0131mc\u0131 se\u00e7in',
  selectDateValidation: 'L\u00fctfen tarih se\u00e7in',
  reminders: 'Hat\u0131rlatmalar',
  seeOtherDates: 'Di\u011fer tarihleri g\u00f6r',
  location: 'Konum',
  about: 'Hakk\u0131nda',
  allExperiences: 'Tüm deneyimler',
  soldOut: 'T\u00fckenmi\u015f',
  addOns: 'Ek Hizmetler',
  reviews: 'De\u011ferlendirmeler',
  reviewSingular: 'de\u011ferlendirme',
  reviewPlural: 'de\u011ferlendirme',
  dateOfExperience: 'Deneyim tarihi',
  readLess: 'Daha Az Oku',
  readMore: 'Devam\u0131n\u0131 Oku',
  seeMore: 'Daha Fazla G\u00f6r',
  details: 'Ayr\u0131nt\u0131lar',
  durationHour: 'saat',
  durationHours: 'saat',
  durationMinutes: 'dk',
  theFollowingVideoDoesNotContainAnyAudio:
    'A\u015fa\u011f\u0131daki video ses i\u00e7ermemektedir',
  by: 'Sunan',
  chooseATime: '{{title}} için bir zaman seçin',
  amenities: 'Olanaklar',
  ticketSalesOpenIn:
    'Bilet sat\u0131\u015flar\u0131 \u015fu s\u00fcrede a\u00e7\u0131l\u0131yor',
  ticketSalesOpen: 'Bilet sat\u0131\u015flar\u0131 a\u00e7\u0131k',
  ticketSalesCloseIn:
    'Bilet sat\u0131\u015flar\u0131 \u015fu s\u00fcrede kapan\u0131yor',
  ticketSalesClose: 'Bilet sat\u0131\u015flar\u0131 kapan\u0131yor',
  ticketSalesClosed: 'Bilet sat\u0131\u015flar\u0131 kapand\u0131',
  comingSoon: '\u00c7ok yak\u0131nda',
  inPartnershipWith: '\u0130\u015f birli\u011fiyle',
  notFoundExperienceTitle: 'Bu deneyim art\u0131k mevcut de\u011fil',
  notFoundExperienceSubtitle:
    'Yay\u0131ndan kald\u0131r\u0131lm\u0131\u015f olabilir veya ba\u011flant\u0131 art\u0131k ge\u00e7erli olmayabilir.',
  deadLinkRecoverySubtitle:
    'Rezervasyon yapabileceğiniz diğer deneyimleri keşfedin',
  viewAllExperiences: 'T\u00fcm Deneyimleri G\u00f6r\u00fcnt\u00fcle',
  experienceBenefits: {
    benefits: {
      basePointsEarn:
        '<p><strong>World of Hyatt hesab\u0131n\u0131za giri\u015f yaparak bu deneyimi rezerve etti\u011finizde uygun her 1 ABD Dolar\u0131 harcama i\u00e7in 5 Temel Puan kazan\u0131n</strong></p>',
      basePoints:
        '<p><strong>World of Hyatt hesab\u0131n\u0131za giri\u015f yaparak bu deneyimi rezerve etti\u011finizde uygun her 1 ABD Dolar\u0131 harcama i\u00e7in 10 Temel Puan kazan\u0131n</strong></p>',
      additionalBonusPoints:
        '<p><strong>World of Hyatt Kredi Kart\u0131n\u0131zla rezerve etti\u011finizde uygun her 1 ABD Dolar\u0131 harcama i\u00e7in ek 4 Bonus Puan kazan\u0131n</strong></p>',
      additionalBonusPointsTier:
        "<p><strong>Kademe durumunuza ba\u011fl\u0131 olarak %30'a kadar ek Bonus Puan kazan\u0131n</strong></p>",
      payWithPoints:
        '<p><strong>Bu deneyimi rezerve ederken Puanlarla \u00d6deyin</strong></p>',
    },
  },
};
